module.exports = __webpack_public_path__ + "static/media/Piercing-eyebrow-bridge.a59ce334.png";